import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import PromoSection from "./components/PromoSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import FaqSection from "./components/FaqSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <PromoSection />
      <AboutSection />
      <ServicesSection />
      <FaqSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
      <WhatsAppButton phoneNumber="34643657183" message="Hola Celeste, me gustaría reservar una sesión de tarot 🔮" />
    </div>
  );
}
